import { css } from "@compiled/react";

import { wacToken } from "@/libraries/design/foundations/index.ts";

import { Head, HeadCell, HeadRow } from "../atoms/head";

export const tableHeadCellIdPrefix = "tblHead_";

export interface HeaderProps {
    titles: string[];
    stickyOffset?: number;
    tableId: string;
}

export const Header = (props: HeaderProps) => {
    const { titles, stickyOffset, tableId } = props;

    return (
        <Head stickyOffset={stickyOffset}>
            <HeadRow>
                {titles.map((heading, index) => {
                    const isEmpty = !heading || heading.trim() === "";
                    if (isEmpty) {
                        return <HeadCell key={index} role="presentation" />;
                    }
                    return (
                        <HeadCell
                            key={index}
                            id={`${tableHeadCellIdPrefix}${tableId}_${index}`}
                        >
                            <div css={headCellDivCss}>
                                <span css={headCellSpanCss}>{heading}</span>
                            </div>
                        </HeadCell>
                    );
                })}
            </HeadRow>
        </Head>
    );
};

const headCellDivCss = css({
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    alignItems: "flex-start"
});

const headCellSpanCss = css({
    color: wacToken("color.primary.black"),
    fontWeight: "700"
});
